module.exports = __webpack_public_path__ + "img/sample_ware_list_vertical.e3fb1628.png";